export const landingFaqQuestions = [
  'bettingSite',
  'guarantees',
  'scans',
  'leagues',
  'free',
] as const;
